import { environment } from '../../../environments/environment';

export const ApiUrlConstants = {
  getAllCountryDetails: '/settings/getAllCountriesDetails',
  getAllCountryDetailsByRfqToken: '/settings/getAllCountriesDetailsByRfqToken',
  
  addIncotermsData:'/settings/addIncotermsData',

  getAllIncotermsBySupplierId:'/settings/getAllIncotermsBySupplierId',
  getAllIncotermsBySupplierIdByRfqToken:
    '/settings/getAllIncotermsBySupplierIdByRfqToken',

  fetchSupplierPaymentDetails:'/settings/fetchSupplierPaymentDetails',

  addPaymentDetails:'/settings/addPaymentDetails',

  updatePaymentDetails:'/settings/updatePaymentDetails',

  addModeOfTransport:'/settings/addModeOfTransport',

  addModeOfTransportToFreightForwarder:'/settings/addModeOfTransportToFreightForwarder',

  getModeofTransportByUserId:'/settings/getModeofTransportByUserId',

  getAllModeOfTransport:'/settings/getAllModeOfTransport',

  addPackaging:'/settings/addPackaging',

  addPackagingToFreightForwarder:'/settings/addPackagingToFreightForwarder',

  getPackagingByUserId:'/settings/getPackagingByUserId',

  getAllPackaging:'/settings/getAllPackaging',

  getSupplierCount: '/settings/getCount',

  getSupplierCountByBrand: '/settings/getCountByBrand',
  getSupplierCountByServiceCategory:'/settings/getSupplierCountByServiceCategory',

  getUserDetails: '/dashboard/getAdminDashboardUsersDetail',

  //#region User routes
  ResendTemporaryPassword: '/users/resendTemporaryPassword',

  currentUserLogin: '/users/login',

  resetUserPassword: '/users/resetUserPassword',

  forgotPassword: '/users/forgotPassword',

  setNewPasswordFromForgot: '/users/newPassword',

  GetUserDetailByToken: '/users/getDetailsByTokenId',

  LogoutCurrentUser: '/users/logout',

  getLoginUserDetails: '/users/getDetails',

  GetUserCategories: '/userCategories',

  /** Get user detail by logged user's email. */
  GetUserDetailByEmail: '/users/getDetailsByEmail',
  /** Update logged user's profile photo URL */
  updateProfilePhotoUrl: '/users/updateProfilePhotoUrl',
  //#endregion

  getPaginatedUserClasses: '',

  getRegistrationFormData: '/users/getRegistrationData',
  registerUser: '/users/signup', //This route to be changed to '/users/signup' when actual connection
  registerUserV2: '/users/signup/v2',

  // !Settings screen routes
  getAccountData: '/settings/accounts',
  getAboutData: '/settings/about',
  getBuyerAboutData: '/settings/buyer/about',
  getSupplierPortData: '/settings/supplierPortsById',
  getSupplierPortDataById: '/settings/supplierPortsById',
  getSupplierBranchData: '/settings/supplierBranches',
  supplierCatalogue: '/settings/catalogues',
  products: '/products', //!Same can be used to fetch single catalogue by passing id after,
  supplierProduct: '/settings/supplierProduct',
  createProduct: '/products/create',
  
  addMySupplierProduct: '/products/addMySupplierProduct',

  assignProduct: '/products/assign',
  assignService: '/services/assign',
  validateProductName: '/products/validateProductName',

  createCategory: '/categories/create',
  updateCategory: '/categories/update',
  fetchAllProductCategory: '/categories',
  fetchArchivedProductCategory: '/categories/fetchArchivedProductCategory',
  fetchAllPendingProductCategory:
    '/categories/productCategory/PendingForApproval',

  fetchAllServiceCategory: '/categories/serviceCategory',
  fetchArchivedServiceCategory: '/categories/fetchArchivedServiceCategory',
  fetchAllPendingServiceCategory:
    '/categories/serviceCategory/PendingForApproval',

  restoreArchivedCategory: '/categories/restore',
  approveCategory: '/categories/aprrove',

  createBrand: '/brands/create',
  updateBrand: '/brands/update',
  fetchAllBrand: '/brands',
  fetchArchivedBrand: '/brands/fetchArchivedBrand',
  restoreArchivedBrand: '/brands/restore',
  fetchAllPendingBrand: '/brands/PendingForApproval',
  approveBrand: '/brands/aprrove',
  
  addPortByAdmin:'/port/addPortByAdmin',
  updatePortByAdmin:'/port/updatePortByAdmin',
  restorePortByAdmin:'/port/restorePortByAdmin',
  importPortsByAdmin:'/port/importPortsByAdmin',

  addTaxDetails:'/users/addTaxDetails',
  updateTaxDetails:'/users/updateTaxDetails',
  getTaxDetails:'/users/getTaxDetails',
  getTaxDetailsByRfqToken:'/users/getTaxDetailsByRfqToken',
  importTaxDetails:'/users/importTaxDetails',

  addTaxDetailsBySupplier:'/users/addTaxDetailsBySupplier', 
  updateTaxDetailsBySupplier:'/users/updateTaxDetailsBySupplier',
  getTaxDetailsBySupplier:'/users/getTaxDetailsBySupplier',
  getTaxDetailsBySupplierByPoToken:'/users/getTaxDetailsBySupplierByPoToken',
  getTaxDetailsBySupplierByRfqToken:'/users/getTaxDetailsBySupplierByRfqToken',
  importTaxDetailsBySupplier:'/users/importTaxDetailsBySupplier',

  productAttachment: '/products/attachment',
  ServiceAttachment: '/services/attachment',
  DeleteServiceCertificate: '/services/deleteServiceCertificate',
  fetchServiceCertificateById: '/services/fetchServiceCertificateById',
  updateServiceCertificateById: '/services/updateServiceCertificate',
  getBulkProductAttachmentUrls: '/products/generateBulkUploadUrls',
  getBulkProductAttachmentUrlsByRfqToken: '/products/generateBulkUploadUrlsByRfqToken',
  productsBySupplier: '/settings/supplier/products',
  getAllCurrenciesByFliterKeyValue: '/settings/getAllCurrenciesByFliterValue',
  getAllCurrenciesByFliterKeyValueByRfqToken:
    '/settings/getAllCurrenciesByFliterValueByRfqToken',
  getAllCategoriesByFliterKeyValue: '/settings/getAllCategoriesByFliterValue',
  getAllSubCategoriesByFliterKeyValue:
    '/settings/getAllSubCategoriesByFliterValue',

  getAllServiceCategoriesByFliterKeyValue:
    '/settings/getAllServiceCategoryByFliterValue',
  getAllUomByFliterKeyValue: '/settings/getAllUomByFliterValue',
  getAllMtmlUomByFliterKeyValue: '/settings/getAllMtmlUomByFliterValue',
  getAllServiceApprovalClassByFliterValue:
    '/settings/getAllServiceApprovalClassByFliterValue',
  getAllBrandsByFliterKeyValue: '/settings/getAllBrandsByFliterValue',
  getAllCountriesByFilterKeyValue: '/settings/getAllCountriesByFliterValue',
  getAllRegionsByFilterKeyValue: '/settings/getAllRegionsByFliterValue',
  getAllCitiesByFilterKeyValue: '/settings/getAllCitiesByFliterValue',

  getAllCountryRegionCities: '/settings/getAllCountryRegionCities',

  getAllMembershipsByFliterKeyValue: '/settings/getAllMembershipsByFliterValue',
  getAllCertificatesByFliterKeyValue:
    '/settings/getAllCertificatesByFliterValue',
  getAllPortsByFliterKeyValue: '/settings/getAllPortsByFliterValue',
  getAllSDGCommitmentsByFliterKeyValue:
    '/settings/getAllSDGCommitmentsByFliterValue',

  getAllAutoCompleteVesselsByFliterValue:
    '/rfq/getAllAutoCompleteVesselsByFliterValue',

  getAllAutocompleteVesselFilterData:
    '/buyer/getAllAutocompleteVesselFilterData',

  getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierId:
    '/settings/getAllSupplierProductByFliterValueAndSupplierId',
  getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierIdByRfqToken:
    '/settings/getAllSupplierProductByFliterValueAndSupplierIdByRfqToken',

  catalogueProductOp: '/settings/catalogue/product',
  getSupplierData: '/settings/supplier/data',
  getMemberships: '/company/memberships',
  getCertificates: '/company/certificates',
  supplierBranchOp: '/supplier/branch',
  sustainabilityOp: '/settings/sustainability',
  organizationalPurposeOp: '/settings/sustainability/organizationalPurpose',
  isoCertificationOp: '/settings/sustainability/isoCertification',
  sustainabilityCommitmentOp: '/settings/sustainability/sustainableCommitments',
  importSustainableData:'/settings/sustainability/importSustainableData',
  ungcParticipationOp: '/settings/sustainability/ungcParticipations',
  additionalDocumentsOp: '/settings/sustainability/additionalDocuments',
  relevantLinksOp: '/settings/sustainability/relevantLinks',
  getImpaData: '/settings/impaproduct',
  supplierImpaproduct: '/settings/supplierImpaproduct',
  getBrandCategory: '/settings/brandcategory',
  getServiceData: '/services',
  getSupplierServiceData: '/services/fetchSupplierService',
  getAllServiceData: '/services/standAloneService',
  createServiceCertificate: '/services/certificate/create',
  createService: '/services/create',
  supplierService: '/services/supplierService',
  addCompanyProductServiceDescription:
    '/company/productServiceDescription/create',
  getProductServiceDescription: '/company/productServiceDescription',
  getPortsByAdmin:'/port/getPortsByAdmin',
  exportPortsByAdmin:'/port/exportPortsByAdmin',

  getUomMtmlUomData:'/uomMtmlUom/getUomMtmlUomData',
  exportUomMtmlUomData:'/uomMtmlUom/exportUomMtmlUomData',
  addUomMtmlUomData:'/uomMtmlUom/addUomMtmlUomData',
  updateUomMtmlUomData:'/uomMtmlUom/updateUomMtmlUomData',
  archiveOrUnarchiveUomMtmlUomData:'/uomMtmlUom/archiveOrUnarchiveUomMtmlUomData',
  importUomMtmlUomData:'/uomMtmlUom/importUomMtmlUomData',

  

  getCatalogueDataById: '/settings/supplierCatalogue',
  CreateCatalogue: '/settings/supplierCatalogue/create',
  searchImpaItems: '/search/serchItems',

  searchImpaItemsMySupplier: '/search/searchItemsMySupplier',
  
  getGeoLocation: '/settings/supplierBranch/location',
  getSearchCountryPorts: '/settings/getAllCountriesPortsByFliterValue',

  getSupplierProfileData: '/supplier/supplierProfileData',
  getLimitedProfileData: '/supplier/supplierProfile',
  searchCategoryItems: '/search/searchCategory',
  searchBrandItems: '/search/searchBrand',
  getArchivedItems: '/settings/archivedItems',
  getDetailedArchivedItems: '/settings/detailedArchivedItems',
  restoreArchivedItems: '/settings/restoreArchivedItems',

  inviteUserBySupplier: '/users/supplier/createUser',
  updateUserDetails: '/users/supplier/updateUserDetails',
  
  fetchUserBySupplier: '/users/supplier/fetchUserBySupplierId',
  fetchSupplierUserByRfqId: '/users/fetchRfqSupplierUserByRfqId',
  assignSupplierUser: '/users/assignsupplieruser',
  assignRFQToBuyerUser: '/users/assignRFQToBuyerUser',
  assignPOToBuyerUser: '/users/assignPOToBuyerUser',
  assignPOToSupplierUser: '/users/assignPOToSupplierUser',
  assignQuoteToSupplierUser:'/users/assignQuoteToSupplierUser',
  getImpaDetailsforRfq: '/rfq/fetchImpaDetails',
  fetchSetupEmailsByUserId: '/users/fetchSetupEmailsByUserId',
  addUpdateVessel: '/buyer/vessel/create',
  importVessels: '/buyer/vessel/import',
  fetchVesselDataByUserId: '/buyer/vessel/fetchVesselData',
  fetchVesselFilterValues: '/buyer/vessel/fetchVesselFilterValues',

  addRecentSearchHistory: '/settings/CreateUserSearchHistory',
  fetchUserSearchHistory: '/settings/fetchUserSearchHistory',
  UpdateUserSearchHistory: '/settings/UpdateUserSearchHistory',

  createSupplierSetup: '/settings/createSupplierSetup',
  fetchSupplierSetup: '/settings/fetchSupplierSetup',
  fetchSupplierSetupByRfqToken: '/settings/fetchSupplierSetupByRfqToken',

  fetchUserInbox: '/users/fetchUserInbox',
  fetchBranchAddressFilterValues: '/buyer/fetchBranchAddressFilterValues',
  getUnreadMailCount: '/users/getUnreadMailCount',
  markAsRead: '/users/markAsRead',
  fetchAllRfqBySupplierId: '/rfq/fetchAllRfqBySupplierId',
  fetchAllServiceRfqBySupplierId: '/services/rfq/fetchAllServiceRfqBySupplierId',
  archiveServiceRfq: '/services/rfq/archive',
  unArchiveServiceRfq: '/services/rfq/unarchive',
  bulkArchiveServiceRfq: '/services/rfq/bulkArchive',
  bulkUnArchiveServiceRfq: '/services/rfq/bulkUnarchive',
  exportAllServiceRfq: '/services/rfq/exportAll',
  assignUserToServiceRfq: '/services/rfq/assignUser',
  unassignUserFromServiceRfq: '/services/rfq/unassignUser',
  getAssignedUsersForServiceRfq: '/services/rfq/getAssignedUsers',
  bulkAssignUsersToServiceRfq: '/services/rfq/bulkAssignUsers',
  fetchAllRfqBybuyerId: '/rfq/fetchAllRfqBybuyerId',
  rfqOperations: '/rfq/rfqOperations',
  rfqOperationsByRfqToken: '/rfq/rfqOperationsByRfqToken',
  buyerRfqOperations: '/rfq/buyerRfqOperations',
  quoteOperations:'/quote/quoteOperations',
  generateSupplierRfqAttachment: '/rfq/generateSupplierRfqAttachment',
  generateSupplierRfqAttachmentByRfqToken:
    '/rfq/generateSupplierRfqAttachmentByRfqToken',
  sendRfqRemindersByBuyer: '/rfq/sendRfqRemindersByBuyer',

  addPortAgent: '/buyer/addPortAgent',
  addFreightForwarder: '/buyer/addFreightForwarder',
  fetchPortAgentByUserId: '/buyer/fetchPortAgentByUserId',
  fetchFreightForwarderByUserId: '/buyer/fetchFreightForwarderByUserId',
  importPortAgent: '/buyer/portAgent/import',
  importFreightForwarder: '/buyer/freightForwarder/import',

  // on Supplier's user page
  importUsers: '/users/supplier/importusers',
  exportAllUsers: '/users/supplier/exportusers',

  importProducts: '/products/importProductsByAdmin',
  importProductsByBuyer: '/products/importProductsByBuyer',
  exportProducts: '/products/exportAllProducstByAdmin',
  exportAllProductsByBuyer: '/products/exportAllProductsByBuyer',
  exportAllImpaDataBySupplierId: '/settings/exportAllImpaDataBySupplierId',
  importAllImpaDataBySupplierId: '/settings/importAllImpaDataBySupplierId',
  exportAllServicesByAdmin: '/services/exportAllServicesByAdmin',
  exportAllServicesByBuyer: '/services/exportAllServicesByBuyer',
  importServicesByAdmin: '/services/importServicesByAdmin',
  importServicesByBuyer: '/services/importServicesByBuyer',
  importSuppliersBranches: '/supplier/importSuppliersBranches',
  exportServicesBySupplierId: '/services/exportServicesBySupplierId',
  importServicesBySupplierId: '/services/importServicesBySupplierId',
  exportAllCategoriesByAdmin:'/categories/exportAllCategoriesByAdmin',
  importCategoriesByAdmin:'/categories/importCategoriesByAdmin',
  importServiceCategoriesByAdmin:'/categories/importServiceCategoriesByAdmin',
  exportAllServiceCategoriesByAdmin:'/categories/exportAllServiceCategoriesByAdmin',
  exportAllBrandsByAdmin:'/brands/exportAllBrandsByAdmin',
  importBrandsByAdmin:'/brands/importBrandsByAdmin',

  fetchQuoteDetailsBySupplierId:'/quote/fetchQuoteDetailsBySupplierId',
  fetchAllQuotesByBuyerId:'/quote/fetchAllQuotesByBuyerId',
  fetchQuoteLineItemDetailsByQuoteId:'/quote/fetchQuoteLineItemsByQuoteId',
  generateQuoteAttachment: '/quote/generateQuotationAttachment',
  quoteOperationsByBUyer: '/quote/quoteOperationsByBUyer',
  generateRfqAttachmentForBuyer: '/rfq/generateBuyerRfqAttachment',

  getRoleData:'/userManagement/role/getRoleData',
  addRoleData:'/userManagement/role/addRoleData',
  updateRoleData:'/userManagement/role/updateRoleData',
  deleteRoleData:'/userManagement/role/deleteRoleData',

  getApprovalData:'/userManagement/approval/getApprovalData',
  deleteApprovalData:'/userManagement/approval/deleteApprovalData',
  updateApprovalData:'/userManagement/approval/updateApprovalData',
  addApprovalData:'/userManagement/approval/addApprovalData',
  addApprovalMappingData:'/userManagement/approvalMapping/addApprovalMappingData',
  updateApprovalMappingData:'/userManagement/approvalMapping/updateApprovalMappingData',
  getApprovalMappingData:'/userManagement/approvalMapping/getApprovalMappingData',
  deleteApprovalMappingData:'/userManagement/approvalMapping/deleteApprovalMappingData',
  getApprovalMappingById:'/userManagement/approvalMapping/getApprovalMappingById',
  assignPOApprovalToBuyerUser: '/users/assignPOApprovalToBuyerUser',
  getSupplierDashBoardData:'/supplier/getSupplierDashBoardData',
  getFilteredSupplierDashBoardRecentsTableData:'/supplier/getFilteredSupplierDashBoardRecentsTableData',
  getBuyerDashBoardData:'/buyer/getBuyerDashBoardData',
  getFilteredBuyerDashBoardRecentOrdersData:'/buyer/getFilteredBuyerDashBoardRecentOrdersData',

  createAndGetInvoiceDetails: '/supplier/createAndGetInvoiceDetails',
  sendInvoice: '/supplier/sendInvoice',
  generateCommercialInvoicePdf: '/supplier/generateCommercialInvoicePdf',
  generatePackingListPdf: '/supplier/generatePackingListPdf',
  generateDeliveryNotePdf: '/supplier/generateDeliveryNotePdf',
  fetchInvoicesListBySupplierId: '/supplier/fetchInvoicesListBySupplierId',
  fetchArchivedInvoicesListBySupplierId: '/supplier/fetchArchivedInvoicesListBySupplierId',
  invoiceListsOperations: '/supplier/invoiceListsOperations',
  exportAllInvoiceListBySupplierId: '/supplier/exportAllInvoiceListBySupplierId',
  // Supplier invoices
  fetchInvoiceStatusSummaryBySupplierId: '/supplier/fetchInvoiceStatusSummaryBySupplierId',
  // Buyer invoices
  fetchInvoiceStatusSummaryByBuyerId: '/buyer/fetchInvoiceStatusSummaryByBuyerId',
  fetchInvoicesListByBuyerId: '/buyer/fetchInvoicesListByBuyerId',
  fetchArchivedInvoicesListByBuyerId: '/buyer/fetchArchivedInvoicesListByBuyerId',
  exportAllInvoiceListByBuyerId: '/buyer/exportAllInvoiceListByBuyerId',
  // Invoice payments
  addInvoicePaymentDetails: '/buyer/addInvoicePaymentDetails',

  // Buyer notification settings
  getBuyerNotificationSettings: '/settings/buyer/fetchBuyerNotificationSettings',
  createBuyerNotificationSettings: '/settings/buyer/createBuyerNotificationSettings',
  updateBuyerNotificationSettings: '/settings/buyer/updateBuyerNotificationSettings',

  // Supplier notification settings
  fetchSupplierNotificationSettings: '/settings/supplier/fetchSupplierNotificationSettings',
  createSupplierNotificationSettings: '/settings/supplier/createSupplierNotificationSettings',
  updateSupplierNotificationSettings: '/settings/supplier/updateSupplierNotificationSettings',

  fetchInvoiceDataById: '/supplier/fetchInvoiceDetailsByInvoiceId',
  createDispatch: '/supplier/createDispatch',
  confirmOrderReceipt:'/buyer/createConfirmOrderReceipt',

  fetchSupplierRfqAttachmentExcelData:"/rfq/fetchSupplierRfqAttachmentExcelData",
  fetchBuyerRfqAttachmentExcelData :"/rfq/fetchBuyerRfqAttachmentExcelData",
  fetchQuoteAttachmentExcelData:"/quote/fetchQuoteAttachmentExcelData",

  // Buyer notifications
  fetchBuyerNotificationsByBuyerId: '/buyer/fetchBuyerNotificationsByBuyerId',
  buyerNotificationsOperations: '/buyer/notificationsOperations',
  markBuyerNotificationAsRead: '/buyer/markBuyerNotificationAsRead',
  markAllBuyerNotificationsAsRead: '/buyer/markAllBuyerNotificationsAsRead',
  // New GET route for buyer notifications list
  getBuyerNotifications: '/buyer/getBuyerNotifications',

  // Supplier notifications
  fetchSupplierNotificationsBySupplierId: '/supplier/fetchSupplierNotificationsBySupplierId',
  supplierNotificationsOperations: '/supplier/notificationsOperations',
  markSupplierNotificationAsRead: '/supplier/markSupplierNotificationAsRead',
  markAllSupplierNotificationsAsRead: '/supplier/markAllSupplierNotificationsAsRead',
  // New GET route for supplier notifications list
  getSupplierNotifications: '/supplier/getSupplierNotifications',

  getSupplierDashBoardTopBuyersData: '/supplier/getSupplierDashBoardTopBuyersData',
  getSupplierDashBoardQuoteSuccessRateByProduct:'/supplier/getSupplierDashBoardQuoteSuccessRateByProduct',
  getSupplierDashBoardPerfomanceScoreData:'/supplier/getSupplierDashBoardPerfomanceScoreData',
  getSupplierDashBoardRfqResponseChartData: '/supplier/getSupplierDashBoardRfqResponseChartData',
  getBuyerDashBoardSupplierPerfomanceChartData:"/buyer/getBuyerDashBoardSupplierPerfomanceChartData",
  getBuyerDashBoardSpendingByProductCategoryData:'/buyer/getBuyerDashBoardSpendingByProductCategoryData',
  getSupplierDashBoardRevenuByProductCategoryData: '/supplier/getSupplierDashBoardRevenuByProductCategoryData',
};
